//var conexion = 'Data Source=10.20.1.168\\DESARROLLOP;Initial Catalog=SIFC_Desarrollo;Persist Security Info=True;User ID=laguilar;Password=$4gu1l4r$;MultipleActiveResultSets=True;Connect Timeout=30;Encrypt=False;TrustServerCertificate=False;ApplicationIntent=ReadWrite;MultiSubnetFailover=False';
//var conexion2 = 'Data Source=10.20.1.168\\DESARROLLOP;Initial Catalog=DB_SIFC_PROD;Persist Security Info=True;User ID=juanmac;Password=#ju4nm4C;MultipleActiveResultSets=True;Connect Timeout=30;Encrypt=False;TrustServerCertificate=False;ApplicationIntent=ReadWrite;MultiSubnetFailover=False';


var prod = true ;
var conexion = "" ;

if(prod == true){
//Conexión a BD PROD
conexion = "%7BToken%3A'7~84%20(1775765680331)'%2Cncs%3A'uga'%2Cmagic%3A'jyqiurt'%2Ccadena%3A'7~84%1194%118%11532%5E%5EWKLGKXHREUI~JU%5BYBLV%5BVKUW~pnggsti~%16ca1gs8V'%7D";
}else{
//Conexión a BD Desarrollo
conexion = "%7BToken%3A'9~66%20(1742927043196)'%2Cncs%3A'oio'%2Cmagic%3A'ydhettahj'%2Ccadena%3A'9~66%1476%146%14714%5BUMJIIZFTCWG~AZNT%5ELvarziwctf~aznt%5Ecjmi~%1907nt%5Eo8e'%7D";
}

async function getHeaders(query, xtoken='09090099', tabla='Tabla|3|' + conexion, token='USUARIOpublicoIEA') {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'Authorization': token,
        'Tabla': tabla,
        'Query': query,
        'Xtoken': xtoken,
        'Registro': {},
        'Conexion': conexion,
        'Sel': 3,
    };
    return headers;
}

async function getFeatch(url, headers) {
    console.log(headers);
    try {

        const response = await fetch(url, { headers: headers });
        const data = await response.json();
        return data;
    } catch (error) {
        return 'Error: ' + error;
    }
}
async function tablaJsonAuto (tabla) {
    //console.log('Arma Json', tabla);
    var tab = '';
    var ban = false;
    if (tabla.length > 0) {tab = JSON.stringify(tabla[0]); ban=true;} else {tab = JSON.stringify(tabla)}
    const nomJson = tab.substr(2, 41);
    //console.log(tab, tab.includes('JSON'),nomJson);
    var tab2 = '';
    ban ? tab2 = tabla[0][nomJson] : tab2 = tabla[nomJson];
    if (ban) {
        for (var i = 1; i < tabla.length; i++) {
            tab2 += tabla[i][nomJson];
          }
    }
    //console.log(tab, JSON.parse(tab2));
    return ban ? JSON.parse(tab2) : JSON.parse(tab2)[0];
  }


async function queryIEASIS(query) {
    console.log('Consulta', query);
    //const query = "select * from perfiles";
    const headers = await getHeaders(query);
    var registro = await getFeatch('https://ieasis.iea.edu.mx/wsnomsis/Api/Tabla/5', headers);
    if (registro.length > 0 && JSON.stringify(registro[0]).includes('JSON')) {
        registro = tablaJsonAuto(registro);
    }
    console.log('Registro:' , registro)
    return registro;
}

module.exports = {
    queryIEASIS
};



/*


Usuarios

Propietario

juanmac

#ju4nm4C
----------
Aplicación

sysuser

#51fc_g3n
*/